import {
  AnalyticsEventName,
  AnalyticsEventNameWithProps,
  AnalyticsEventPropsOf,
} from 'modules/analytics/plausible/types'
import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'

// Hooks
import { useTrackEvent } from './useTrackEvent'

export const useTrackEventInView = <TEventName extends AnalyticsEventName>(
  event: TEventName,
  eventProps?: TEventName extends AnalyticsEventNameWithProps
    ? AnalyticsEventPropsOf<TEventName> & { target?: string }
    : never
) => {
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  })

  const { trackEvent } = useTrackEvent()

  useEffect(() => {
    if (inView) {
      trackEvent(event, eventProps)
    }
  }, [event, eventProps, inView, trackEvent])

  return { ref }
}
